import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
const MaterialOpeningClosing = () => {
    const token = getAuthToken();
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [products, setProducts] = useState([]);
    const [materials, setMaterials] = useState([]);
    const [filters, setFilters] = useState({
        start_date: "",
        end_date: "",
        product_id: "",
        material_id: "",
    });
    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
    });
    const [materialModal, setMaterialModal] = useState(false);
    const [materialProducts, setMaterialProducts] = useState([]);
    const [materialLoading, setMaterialLoading] = useState(false);
    const [selectedMaterial, setSelectedMaterial] = useState(null);
    useEffect(() => {
        getProducts();
        getMaterials();
    }, []);
    const openMaterialModal = async (item) => {
        const token = getAuthToken();

        if (!token) {
            toast.error("Authentication token not found.");
            return;
        }

        if (!filters.start_date || !filters.end_date) {
            toast.warning("Please select Start Date and End Date.");
            return;
        }

        if (!item?.material_id) {
            toast.warning("Material ID not found.");
            return;
        }

        try {
            setSelectedMaterial(item);
            setMaterialModal(true);
            setMaterialLoading(true);
            setMaterialProducts([]);

            const response = await axios.post(
                `${config.API}/senmanager/materialusedinproduct`,
                {
                    material_id: item.material_id,
                    start_date: filters.start_date,
                    end_date: filters.end_date,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.data?.success) {
                toast.warning(
                    response.data?.message || "No data available."
                );
                return;
            }

            setMaterialProducts(response.data?.data || []);
        } catch (error) {
            console.error("Material consumption error:", error);

            toast.error(
                error.response?.data?.message ||
                "Failed to load material consumption."
            );

            setMaterialProducts([]);
        } finally {
            setMaterialLoading(false);
        }
    };
    const getProducts = async () => {
        try {
            const response = await axios.get(`${config.API}/product/list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            console.log("products", response.data.products);
            setProducts(response.data.products || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getMaterials = async () => {
        try {
            const response = await axios.get(`${config.API}/material/master/list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            console.log("materials", response);
            setMaterials(response.data.materials || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getReport = async (page = 1) => {
        const token = getAuthToken();
        if (!token) {
            toast.error("Authentication token not found.");
            return;
        }

        if (!filters.start_date || !filters.end_date) {
            toast.warning("Please select Start Date and End Date.");
            return;
        }

        try {
            setLoading(true);

            const payload = {
                start_date: String(filters.start_date),
                end_date: String(filters.end_date),
                product_id: filters.product_id
                    ? Number(filters.product_id)
                    : null,
                material_id: filters.material_id
                    ? Number(filters.material_id)
                    : null,
                page: Number(page),
                per_page: 10,
            };

            console.log("REQUEST PAYLOAD:", payload);

            const response = await axios.post(
                `${config.API}/senmanager/materialopeningclosing`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.success) {
                setRows(response.data.data || []);

                setPagination(
                    response.data.pagination || {
                        current_page: 1,
                        last_page: 1,
                        per_page: 10,
                        total: 0,
                    }
                );
            } else {
                setRows([]);
                toast.warning(
                    response.data.message || "No data found."
                );
            }

        } catch (error) {
            console.error("REPORT ERROR:", error);
            console.error("RESPONSE:", error.response?.data);

            setRows([]);

            toast.error(
                error.response?.data?.message ||
                "Something went wrong. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };
    const exportExcel = async () => {
        const token = getAuthToken();

        if (!token) {
            toast.error("Authentication token not found.");
            return;
        }

        if (!filters.start_date || !filters.end_date) {
            toast.warning("Please select Start Date and End Date.");
            return;
        }

        try {
            setLoading(true);

            const response = await axios.post(
                `${config.API}/senmanager/materialopeningclosing`,
                {
                    start_date: filters.start_date,
                    end_date: filters.end_date,
                    product_id: filters.product_id || null,
                    material_id: filters.material_id || null,

                    // Tell backend we want ALL records
                    export: true,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.data.success) {
                toast.warning(
                    response.data.message || "No data available to export."
                );
                return;
            }

            const allRows = response.data.data || [];

            if (!allRows.length) {
                toast.warning("No data available to export.");
                return;
            }

            const excelData = allRows.map((item, index) => ({
                "#": index + 1,
                Product: item.product_name,
                Material: item.material_name,
                "Unit": item.unit_of_measurement,
                "Opening Stock": Number(
                    item.opening_stock || 0
                ),
                "Consumed Quantity": Number(
                    item.consumed_qty || 0
                ),
                "Other Product": Number(
                    item.other_product_consumed_qty || 0
                ),
                "Closing Stock": Number(
                    item.closing_stock || 0
                ),
            }));

            const worksheet =
                XLSX.utils.json_to_sheet(excelData);

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Material Report"
            );

            XLSX.writeFile(
                workbook,
                "Material_Report.xlsx"
            );

            toast.success(
                `Exported ${allRows.length} records successfully.`
            );

        } catch (error) {
            console.error("Export error:", error);

            toast.error(
                error.response?.data?.message ||
                "Failed to export report."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid mt-4">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">
                    <h5 className="mb-0">
                        Material Opening & Closing Report
                    </h5>
                </div>

                <div className="card border-0 shadow-sm mb-4">
                    <div className="card-body p-4">

                        {/* Filter Header */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                                <h6 className="mb-1 fw-semibold">
                                    Report Filters
                                </h6>
                                <small className="text-muted">
                                    Select date range and filters to generate the report
                                </small>
                            </div>
                        </div>

                        <div className="row g-3 align-items-end">

                            {/* Start Date */}
                            <div className="col-12 col-md-2">
                                <label className="form-label fw-semibold small">
                                    Start Date
                                </label>

                                <input
                                    type="date"
                                    className="form-control"
                                    value={filters.start_date}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            start_date: e.target.value,
                                        })
                                    }
                                />
                            </div>

                            {/* End Date */}
                            <div className="col-12 col-md-2">
                                <label className="form-label fw-semibold small">
                                    End Date
                                </label>

                                <input
                                    type="date"
                                    className="form-control"
                                    value={filters.end_date}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            end_date: e.target.value,
                                        })
                                    }
                                />
                            </div>

                            {/* Product */}
                            <div className="col-12 col-md-2">
                                <label className="form-label fw-semibold small">
                                    Product
                                </label>

                                <select
                                    className="form-select"
                                    value={filters.product_id}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            product_id: e.target.value,
                                        })
                                    }
                                >
                                    <option value="">
                                        All Products
                                    </option>

                                    {products.map((item) => (
                                        <option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Material */}
                            <div className="col-12 col-md-2">
                                <label className="form-label fw-semibold small">
                                    Material
                                </label>

                                <select
                                    className="form-select"
                                    value={filters.material_id}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            material_id: e.target.value,
                                        })
                                    }
                                >
                                    <option value="">
                                        All Materials
                                    </option>

                                    {materials.map((item) => (
                                        <option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.material_name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Search */}
                            <div className="col-12 col-md-2">
                                <button
                                    type="button"
                                    className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                                    onClick={() => getReport(1)}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                            Loading...
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-search" />
                                            Search
                                        </>
                                    )}
                                </button>
                            </div>

                            {/* Excel */}
                            <div className="col-12 col-md-2">
                                <button
                                    type="button"
                                    className="btn btn-success w-100 d-flex align-items-center justify-content-center gap-2"
                                    onClick={exportExcel}
                                    disabled={loading}
                                >
                                    <i className="bi bi-file-earmark-excel" />
                                    Export Excel
                                </button>
                            </div>

                        </div>
                    </div>

                    {/* Table */}

                    <div className="table-responsive">

                        <table className="table table-bordered table-hover table-striped align-middle">

                            <thead className="table-dark">

                                <tr>

                                    <th width="60">#</th>
                                    <th>Material Code</th>
                                    <th>Material</th>
                                    <th>UOM </th>
                                    <th className="text-end">
                                        Opening Stock
                                    </th>
                                    <th className="text-end">
                                        Consumed Quantity
                                    </th>
                                    <th>
                                        Ordered Quantity
                                    </th>
                                    <th className="text-end">
                                        Closing Stock
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                {loading ? (

                                    <tr>

                                        <td
                                            colSpan="6"
                                            className="text-center"
                                        >
                                            Loading...
                                        </td>

                                    </tr>

                                ) : rows.length > 0 ? (

                                    rows.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.material_code}</td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0 text-decoration-none fw-semibold"
                                                    onClick={() => openMaterialModal(item)}
                                                >
                                                    {item.material_name}
                                                </button>
                                            </td>
                                            <td>{item.unit_of_measurement}</td>
                                            <td className="text-end">
                                                {Number(item.opening_stock).toLocaleString()}
                                            </td>
                                            <td className="text-end">
                                                {Number(item.consumed_qty).toLocaleString()}
                                            </td>
                                            <td>
                                                {Number(item.ordered_qty).toLocaleString() || item.ordered_qty}
                                            </td>
                                            <td className="text-end">
                                                {Number(item.closing_stock).toLocaleString()}
                                            </td>

                                        </tr>

                                    ))

                                ) : (

                                    <tr>

                                        <td
                                            colSpan="6"
                                            className="text-center text-danger"
                                        >
                                            No Data Found
                                        </td>

                                    </tr>

                                )}

                            </tbody>

                        </table>
                        {materialModal && (
                            <div
                                className="modal fade show d-block"
                                tabIndex="-1"
                                style={{ background: "rgba(0,0,0,.5)" }}
                            >
                                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                                    <div className="modal-content border-0 shadow-lg rounded-3">

                                        <div className="modal-header">
                                            <div>
                                                <h5 className="modal-title fw-bold mb-1">
                                                    Material Consumption
                                                </h5>

                                                <small className="text-muted">
                                                    {selectedMaterial?.material_name || "-"}
                                                </small>
                                            </div>

                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => setMaterialModal(false)}
                                            />
                                        </div>

                                        <div className="modal-body">

                                            {materialLoading ? (
                                                <div className="text-center py-5">
                                                    <div className="spinner-border text-primary" />
                                                    <div className="text-muted mt-2">
                                                        Loading material details...
                                                    </div>
                                                </div>
                                            ) : materialProducts.length > 0 ? (
                                                <>
                                                    {/* Material Header */}
                                                    <div className="bg-light border rounded-3 p-3 mb-3">
                                                        <div className="row g-3">

                                                            <div className="col-md-6">
                                                                <small className="text-muted d-block">
                                                                    Material
                                                                </small>
                                                                <strong>
                                                                    {materialProducts[0]?.material_master?.material_name || "-"}
                                                                </strong>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <small className="text-muted d-block">
                                                                    Material Code
                                                                </small>
                                                                <strong>
                                                                    {materialProducts[0]?.material_master?.material_code || "-"}
                                                                </strong>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* Product Table */}
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-hover align-middle mb-0">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th>S.No</th>
                                                                    <th>Product</th>
                                                                    <th className="text-end">
                                                                        Consumed
                                                                    </th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {materialProducts.map((item, index) => (
                                                                    <tr key={item.product_id || index}>
                                                                        <td>{index + 1}</td>

                                                                        <td>
                                                                            <div className="fw-semibold">
                                                                                {item.product?.name || "-"}
                                                                            </div>
                                                                        </td>

                                                                        <td className="text-end fw-semibold text-primary">
                                                                            {Number(item.quantity || 0).toLocaleString("en-IN")}
                                                                            {" "}
                                                                            {selectedMaterial.unit_of_measurement || "Pcs"}
                                                                        </td>
                                                                    </tr>
                                                                ))}

                                                                <tr className="table-light fw-bold">
                                                                    <td colSpan="2" className="text-end">
                                                                        Total Consumed
                                                                    </td>
                                                                    <td className="text-end text-primary">
                                                                        {materialProducts
                                                                            .reduce(
                                                                                (total, item) => total + Number(item.quantity || 0),
                                                                                0
                                                                            )
                                                                            .toLocaleString("en-IN")}{" "}
                                                                        {selectedMaterial?.unit_of_measurement || "Pcs"}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="text-center text-muted py-5">
                                                    No material consumption found.
                                                </div>
                                            )}
                                        </div>

                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm px-4"
                                                onClick={() => setMaterialModal(false)}
                                            >
                                                Close
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        )}
                        {pagination.last_page > 1 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">

                                <div className="text-muted">
                                    Showing{" "}
                                    {(pagination.current_page - 1) *
                                        pagination.per_page +
                                        1}{" "}
                                    to{" "}
                                    {Math.min(
                                        pagination.current_page *
                                        pagination.per_page,
                                        pagination.total
                                    )}{" "}
                                    of {pagination.total} records
                                </div>

                                <div className="d-flex gap-2">

                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        disabled={pagination.current_page === 1}
                                        onClick={() =>
                                            getReport(
                                                pagination.current_page - 1
                                            )
                                        }
                                    >
                                        Previous
                                    </button>

                                    <span className="btn btn-sm btn-primary">
                                        {pagination.current_page} /{" "}
                                        {pagination.last_page}
                                    </span>

                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        disabled={
                                            pagination.current_page ===
                                            pagination.last_page
                                        }
                                        onClick={() =>
                                            getReport(
                                                pagination.current_page + 1
                                            )
                                        }
                                    >
                                        Next
                                    </button>

                                </div>
                            </div>
                        )}
                    </div>

                </div>

            </div>

        </div >
    );
};

export default MaterialOpeningClosing;